import React, { useState, useEffect } from 'react';
import Header from '../../components/common/Header';
import DoctorBottomNav from '../../components/doctor/DoctorBottomNav';
import { getDoctorQR } from '../../services/doctorService';
import { useAuth } from '../../context/AuthContext';

export default function DoctorQRPage() {
  const { user }    = useAuth();
  const [qr, setQR]          = useState(null);
  const [url, setUrl]        = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoctorQR()
      .then(res => { setQR(res.qrBase64); setUrl(res.profileUrl); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleDownload = () => {
    if (!qr) return;
    const a = document.createElement('a');
    a.href = qr;
    a.download = `${user?.name || 'doctor'}-faristaa-qr.png`;
    a.click();
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: `Book appointment with ${user?.name}`, url });
      } catch {}
    } else {
      navigator.clipboard.writeText(url);
      import('react-hot-toast').then(m => m.default.success('Profile link copied!'));
    }
  };

  return (
    <div className="page-container">
      <Header title="My QR Code" showBack />

      <div className="px-4 pt-4 pb-24 max-w-md mx-auto space-y-4">

        {/* Info card */}
        <div className="bg-gradient-to-br from-primary to-teal-600 rounded-3xl p-5 text-white text-center">
          <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3">
            <i className="fa-solid fa-qrcode text-white text-2xl" />
          </div>
          <h2 className="text-lg font-black font-heading mb-1">Your Profile QR</h2>
          <p className="text-white/80 text-sm">Patients scan this to visit your profile and book appointments</p>
        </div>

        {/* QR Code */}
        <div className="bg-white rounded-3xl border border-border p-6 text-center shadow-sm">
          {loading ? (
            <div className="flex items-center justify-center py-16">
              <div className="w-10 h-10 border-2 border-primary-light border-t-primary rounded-full animate-spin" />
            </div>
          ) : qr ? (
            <>
              <div className="inline-block p-4 bg-white border-2 border-primary/20 rounded-2xl shadow-sm mb-4">
                <img src={qr} alt="Doctor QR Code" className="w-52 h-52" />
              </div>
              <p className="text-xs text-text-muted mb-1">Dr. {user?.name}</p>
              <p className="text-[10px] text-text-muted break-all px-4">{url}</p>
            </>
          ) : (
            <div className="py-8 text-text-muted">
              <i className="fa-solid fa-triangle-exclamation text-2xl mb-2" />
              <p className="text-sm">Could not generate QR</p>
            </div>
          )}
        </div>

        {/* Actions */}
        {qr && (
          <div className="space-y-3">
            <button onClick={handleDownload}
              className="w-full py-3.5 bg-primary text-white rounded-2xl font-bold text-sm flex items-center justify-center gap-2 shadow-lg shadow-primary/20">
              <i className="fa-solid fa-download" />Download QR Code
            </button>
            <button onClick={handleShare}
              className="w-full py-3.5 border-2 border-primary text-primary rounded-2xl font-bold text-sm flex items-center justify-center gap-2">
              <i className="fa-solid fa-share-nodes" />Share Profile Link
            </button>
          </div>
        )}

        {/* Instructions */}
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 space-y-2">
          <p className="text-xs font-bold text-amber-800 flex items-center gap-2">
            <i className="fa-solid fa-lightbulb text-amber-500" />How to use
          </p>
          <ul className="space-y-1.5 text-xs text-amber-700">
            <li className="flex items-start gap-2"><i className="fa-solid fa-circle-check text-amber-500 mt-0.5 flex-shrink-0" />Print and display at your clinic</li>
            <li className="flex items-start gap-2"><i className="fa-solid fa-circle-check text-amber-500 mt-0.5 flex-shrink-0" />Share on WhatsApp or social media</li>
            <li className="flex items-start gap-2"><i className="fa-solid fa-circle-check text-amber-500 mt-0.5 flex-shrink-0" />Patients scan → see your profile → book appointment</li>
          </ul>
        </div>
      </div>

      <DoctorBottomNav />
    </div>
  );
}
